// extracted by mini-css-extract-plugin
export default {"scrollButtons":"ScrollBtn_scrollButtons__VE1oX","next":"ScrollBtn_next__5mwfj","prew":"ScrollBtn_prew__dRB5F"};